import * as screenActions from '../../Common/actions/Screen';
import * as designScreenActions from '../../Design/actions/Screen';
import * as fieldTypes from '../../../../constants/FieldTypes';
import * as itemTypes from '../../../../constants/ItemTypes';
import {showConfirmMessage} from '../../../../_shared/Messages/actions/MessageActions';
import {messagesIds} from '../../../../_shared/Messages/consts';
import {getLocalizedMoreInfoText, getLocalizedText, texts} from '../../../../constants/TextConst';
import messagesText from '../../../../_shared/Messages/texts';

let setJsDataSet;

export function initFunctions(funcs) {
    if (funcs) {
        screenActions.initFunctions(funcs);
        setJsDataSet = funcs.setJsDataSet;
    }
}

export function insertFields(screen, data) {
    screenActions.insertFields(screen, data);
}

export function getData(screen) {
    screenActions.getData(screen);
}

export function saveData(screensStore, closeCallback) {
    const {selectedScreen} = screensStore;
    saveScreenData(screensStore, selectedScreen, null, closeCallback);
}

export function saveScreenData(screensStore, selectedScreen, endCallback?, closeCallback?) {
    selectedScreen.collection.fields.forEach(field => {
        if (!field.changed) {
            field.changed = childrenHaveChanges(field);
        }
    });

    closeCallback && selectedScreen.setLoading(true);
    endCallback && endCallback();

    const saveCallback = () => {
        selectedScreen.setLoading(false);
        selectedScreen.setChanged(false);
        closeCallback && closeCallback(false);
    };

    setJsDataSet(
        selectedScreen.name,
        selectedScreen.collection.fields,
        closeCallback && saveCallback
    );
}

function childrenHaveChanges(field) {
    if (field.collection.fields && field.collection.fields.length) {
        for (let i = 0; i < field.collection.fields.length; i++) {
            const fieldChild = field.collection.fields[i];
            if (fieldChild.changed) {
                return (field.changed = true);
            }
            if (field.collection.fields && field.collection.fields.length) {
                if (childrenHaveChanges(fieldChild)) {
                    return (field.changed = true);
                }
            }
        }
    } else {
        return field.changed;
    }
}

export function isSelectEnabled(field) {
    return (
        !field.isChanging &&
        (!field.hidden || field.type === fieldTypes.TAB || field.repType === itemTypes.Field)
    );
}

export function selectScrollField(field) {
    selectField(field);
    screenActions.scrollField(field);
}

export function selectField(field, selectAny?) {
    const {screen} = field;
    // processing click on unselected field
    if (!field.isSelected && (field.isSelectable || selectAny)) {
        screen.setSelected(field);
    }
    // if there's an 'active' field (with actions panel opened) and it's not the same as we're selecting now,
    // we should disactivate it to avoid clumsy situation when one field is selected and another is active

    if (screen.active && !field.isActive) {
        screen.setActive(null);
    }
}

export function activateField(field) {
    return designScreenActions.activateField(field);
}

export function isMovementsPanelShown(screen) {
    return (
        screen.selected &&
        !screen.selected.isHiddenImage &&
        screen.selected.repType === itemTypes.Field
    );
}

function saveAndChangeScreen(screensStore, screenId) {
    const prevScreen = screensStore.selectedScreen;
    screensStore.setSelectedScreenKey(screenId);
    screensStore.selectedScreen.setLoading(true);
    saveScreenData(screensStore, prevScreen, () => _changeScreen(screensStore.selectedScreen));
}

function _changeScreen(screen) {
    if (screen.collection.isEmpty) {
        getData && getData(screen);
    } else {
        screen.setLoading(false);
    }
}

export function changeScreen(screensStore, screenId) {
    if (screenId !== screensStore.selectedScreenKey) {
        if (screensStore.selectedScreen.changed) {
            showConfirmMessage({
                id: messagesIds.screens.changeScreenConfirm,
                title: getLocalizedText(texts.saveChanges),
                moreInfo: getLocalizedMoreInfoText(texts.saveChanges),
                cancleButtonText: messagesText.noChangedMyMind,
                confirmButtonText: messagesText.yes,
                onConfirm: () => {
                    saveAndChangeScreen(screensStore, screenId);
                },
                onCancel: () => {
                    screensStore.setSelectedScreenKey(screenId);
                    screensStore.selectedScreen.setLoading(true);
                    _changeScreen(screensStore.selectedScreen);
                }
            });
        } else {
            screensStore.setSelectedScreenKey(screenId);
            screensStore.selectedScreen.setLoading(true);
            _changeScreen(screensStore.selectedScreen);
        }
    }
}

export const systemReportScreenActions = {
    initFunctions,
    insertFields,
    saveData,
    changeScreen
};
